export const platformVersion = '^10.1.2';
